import MFEContainer from "./MFEContainer";
export default MFEContainer;
